import { Component, HostBinding, Inject, OnInit, OnDestroy } from '@angular/core';
import {
	MULTISELECT_DATA,
	MULTISELECT_DATA_CLICK_CALLBACK,
	MULTISELECT_DATA_FILTER,
} from '@utils/constants/injectortokens';
import { Observable } from 'rxjs/Observable';

import { DialogService } from '@app/services';
import { DepartmentService } from '@app/services/department/department.service';
import { AddDepartmentsComponent } from '@app/pages/departments/adddepartment/adddepartment.component';

@Component({
	selector: 'app-users-select-data-members',
	templateUrl: './users-select-data-members.component.html',
	styleUrls: ['./users-select-data-members.component.scss'],
})
export class UsersSelectDataMembersComponent implements OnInit, OnDestroy {
	@HostBinding('class.n2p-dropdown-data') style = false;
	departments: Array<any> = [];
	filteredDepartments: Array<any> = [];
	callback: any;
	filterSub: any;
	constructor(
		@Inject(MULTISELECT_DATA) data: any,
		@Inject(MULTISELECT_DATA_CLICK_CALLBACK) callback: any,
		@Inject(MULTISELECT_DATA_FILTER) private filter: Observable<string>,
		private dialogService: DialogService,
		private departmentService: DepartmentService,
	) {
		this.callback = callback;
		this.departments = data;
		this.filteredDepartments = data;
	}

	delete() {
		this.callback();
	}

	clicked(item) {
		item.selected = !item.selected;
		this.callback({
			...item,
			type: 'd',
			selected: item.selected,
		});
	}

	selectItem(item) {
		item.selected = !item.selected;
	}

	createDepartment() {
		const dialogRef = this.dialogService.create(AddDepartmentsComponent, {
			width: 480,
		});

		dialogRef.onDismiss().subscribe(res => {
			if (res) {
				this.getAllDepartments();
			}
		});
	}

	getAllDepartments(): void {
		this.departmentService.getAccountDepartments().subscribe(result => {
			if (!result.hasError) {
				this.departments = result.data;
				this.filteredDepartments = result.data;

				this.callback({ new: true, data: this.departments });
			}
		});
	}

	ngOnInit() {
		this.style = true;
		this.filterSub = this.filter.subscribe(str => {
			if (str) {
				this.filteredDepartments = this.departments.filter(u => {
					return `${u.name.toLowerCase()}`.indexOf(str.toLowerCase()) !== -1;
				});
			} else {
				this.filteredDepartments = this.departments;
			}
		});
	}

	ngOnDestroy() {
		this.filterSub.unsubscribe();
	}
}
